export const PLATFORM_PATHS = {
  STORES: {
    ROOT: '/stores',
    // STORE_INFO: 'stores/store-info',
  },
  ACCOUNTS: {
    ROOT: '/account',
    // ADD: 'account/add-account',
    // EDIT: 'account/edit-account',
    // INFO: 'account/account-info',
  },
  PRODUCTS: {
    ROOT: '/products',
  },
  SETTINGS: {
    MASTER_STORE: '/settings/master-store',
    PLAN: '/settings/plan',
  },
  THEMES: {
    ROOT: '/themes',
  },
  REPORT: {
    ORDER: '/reports/orders-revenue',
  },
  PROMOTIONS: {
    ROOT: '/promotions',
  },
  CONTENT: {
    ROOT: '/content',
  },
  CUSTOMER_PROFILES: {
    ROOT: '/customer-profiles',
  },
  PROVISIONING_PROFILES: {
    ROOT: '/provisioning-profiles',
  },
} as const

export const isPathBelongTo = (pathname: string, paths: string[]): boolean =>
  paths.some((path) => pathname.toLowerCase() === path.toLowerCase())

export const isShowPlatform = (pathname: string): boolean => {
  const platformPaths = Object.values(PLATFORM_PATHS).flatMap(Object.values)
  return isPathBelongTo(pathname, platformPaths)
}
